const quotes = [
  {
    text: "「我做这些，就是图个开心，跟钱没什么关系。」",
    who: "某综艺选手",
    out: "出处 · 早年访谈（2014）",
    note: "同年在后台谈酬劳的分镜也被挖到",
  },
  {
    text: "「你们别乱写，我跟他关系其实好得很。」",
    who: "某唱跳艺人",
    out: "出处 · 早年直播口播（2016）",
    note: "同期台前台后的态度，对不上这一句",
  },
  {
    text: "「这种话我从来不说的，都是他们编排的。」",
    who: "某过气顶流",
    out: "出处 · 早年群访录音（2018）",
    note: "考古发现里，原带与剪辑版差了半句",
  },
  {
    text: "「今天到这吧，有些事讲多了没意思。」",
    who: "某评委",
    out: "出处 · 早年节目花絮（2019）",
    note: "说完这句，当月再未同框",
  },
];

export default function QuoteFiles() {
  return (
    <section id="quotes" className="scroll-mt-4 bg-[#faf5eb]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#b1401f]">
              <i className="ri-quote-text" aria-hidden="true"></i>
              早年言论 · 语录卷宗
            </h4>
            <h3 className="font-display mt-3 text-2xl font-black text-[#1a160e] md:text-4xl">
              当年他们说过的那几句
            </h3>
          </div>
          <p className="text-sm text-[#6f6552]">只收录能找回原始出处的早年言论。</p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {quotes.map((q) => (
            <article
              key={q.out}
              className="flex flex-col justify-between border border-[#e3d7bd] bg-[#f3ead8] p-6 md:p-7"
            >
              <div>
                <i className="font-display block text-4xl leading-none text-[#b1401f] select-none" aria-hidden="true">
                  “
                </i>
                <p className="font-display mt-2 text-base leading-8 font-bold text-[#1a160e] md:text-lg">
                  {q.text}
                </p>
              </div>
              <div className="mt-6 border-t border-[#e3d7bd] pt-4">
                <p className="text-sm font-medium text-[#1a160e]">{q.who}</p>
                <p className="mt-1 text-[11px] tracking-widest text-[#6f6552]">{q.out}</p>
                <p className="mt-2 flex items-center gap-1.5 text-[11px] text-[#978a72]">
                  <i className="ri-file-search-line" aria-hidden="true"></i>
                  {q.note}
                </p>
              </div>
            </article>
          ))}
        </div>

        <button
          type="button"
          className="mt-8 flex cursor-pointer items-center gap-2 text-sm font-medium text-[#b1401f] transition hover:gap-3"
        >
          翻开完整语录卷（全 12 则）
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  );
}